import { Component, Optional, Inject } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { UntypedFormBuilder } from '@angular/forms';
import { IncidentUnderageAffidavitModel } from '../../models/incident-underage-affidavit.model';
import { UnderageIncidentService } from '../../services/underage-incident.service';
import { IncidentTypeService } from '../../services/incident-type.service';
import { IncidentDialogContext } from '../../shared/incident-dialog-context.model';
import { IncidentModalComponent } from '../../incident-modal.component';
import { CitingAgencyType } from '../../models/citing-agency-type.model';
import { CitingAgencyTypeService } from '../../services/citing-agency-type.service';
import { IncidentService } from '../../services/incident.service';
import { MvdModalService } from '../../../shared/services/modal/mvd-modal.service';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { ProhibitionService } from '../../../prohibition/services/prohibition.service';
import { EnumDataService } from '../../services/enums.DataService';

@Component({
    templateUrl: './underage-incident-modal.html'
})
export class UnderageIncidentModalComponent extends IncidentModalComponent<IncidentUnderageAffidavitModel> {
    public citingAgencyTypes: CitingAgencyType[];
    public accidentTypes: any[];

    constructor(location: PlatformLocation,
        fb: UntypedFormBuilder,
        public service: UnderageIncidentService,
        public dialogRef: MatDialogRef<IncidentModalComponent<IncidentUnderageAffidavitModel>>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: IncidentDialogContext<IncidentUnderageAffidavitModel>,
        public prohibitionService: ProhibitionService,
        public citingAgencyTypeService: CitingAgencyTypeService,
        public incidentService: IncidentService,
        modalService: MvdModalService,
        typeService: IncidentTypeService,
        EnumDataService: EnumDataService
    ) {
        super(data, prohibitionService, fb, dialogRef, modalService, incidentService, EnumDataService, typeService, location);
    }

    protected onLoadLookups(callback: (error?) => void): void {
        this.citingAgencyTypeService.getAll().subscribe(r => this.onGetCitingAgencyTypes(r.result, callback), callback);
    }

    private onGetCitingAgencyTypes(result: CitingAgencyType[], callback: (error?) => void): void {

        this.citingAgencyTypes = result;

        callback();
    }

    protected onLoadIncident(callback: (error?) => void): void {
        this.service.getIncident(this.data.incident.incidentNumberId).subscribe(r => this.onGetIncidentCompleted(r, callback), e => callback(e));
    }

    private onGetIncidentCompleted(incident: IncidentUnderageAffidavitModel, callback: (error?) => void): void {
        this.data.incident = incident;

        this.showUserInput = true;

        callback();
    }

    protected onSaveIncident(callback: (error?: any) => void): void {

        var citingAgency = this.incidentForm.get('citingAgencyTypeId').value;
        this.data.incident.citingAgencyTypeId = citingAgency.id;

        this.data.incident.bac = this.incidentForm.get('bac').value;
        this.data.incident.orderOfSuspensionServedByOfficerDate = this.incidentForm.get('orderOfSuspensionServedByOfficerDate').value;

        this.service.saveIncident(this.data.incident).subscribe(r => { }, callback, callback);
    }

    protected onDeleteIncident(callback: () => void): void {
        this.service.deleteIncident(this.data.incident.incidentNumberId)
            .subscribe(_ => { }, e => this.handleError, () => {
                this.dialogRef.close(true);
            });
    }
}
